import React, { useEffect, useState } from 'react';
import { Box, ListItemText, ListItemButton, Typography, Collapse, IconButton } from '@mui/material';
import { useLocation } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { gUtils } from '@/utils/gUtils';
import { navIconMap } from './navIcons';

const sxStyle = (matchPath, toPath) => {
  return {
    borderRadius: '6px',
    backgroundColor: matchPath === toPath ? '#F8F8F8' : 'transparent',
    '&:hover': {
      backgroundColor: '#F8F8F8',
    },
  };
};

const externalStyle = () => {
  return {
    borderRadius: '6px',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#F8F8F8',
    },
  };
};

export const NavigatorItem = ({ to, name, icon, location, external = false, onClick }) => {
  const [matchPath, setMatchPath] = useState('');
  const Icon = navIconMap[icon];

  useEffect(() => {
    if (location) {
      const currentPath = location.pathname === '/' ? '/' : location.pathname.split('/')[2];
      setMatchPath(currentPath);
    }
  }, [location]);

  const isActive = matchPath === (to === '/' ? '/' : to.split('/')[2]);

  return (
    <>
      <ListItemButton
        onClick={onClick}
        component={external ? 'a' : Link}
        to={to}
        target={external ? '_blank' : undefined}
        sx={external ? externalStyle : sxStyle(matchPath, to === '/' ? '/' : to.split('/')[2])}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
          {Icon && (
            <Icon
              {...(['contacts', 'me'].includes(icon) ? { selected: isActive } : {})}
              size={20}
              sx={{
                fontSize: 20,
                flexShrink: 0,
                color: isActive ? '#28aeb1' : 'inherit',
              }}
            />
          )}

          <ListItemText
            sx={{
              '>span': {
                fontWeight: 'bold',
                color: isActive ? '#28aeb1' : 'inherit',
              },
            }}
          >
            {name}
          </ListItemText>
        </Box>
      </ListItemButton>
    </>
  );
};

const getStyleAttributes = (matchPath, router) => {
  const isSectionMatched = matchPath.startsWith(router);
  if (matchPath === router || isSectionMatched) {
    return {
      backgroundColor: '#F8F8F8',
      opacity: 1,
    };
  } else {
    return {
      backgroundColor: 'transparent',
      opacity: 0.3,
    };
  }
};

const openStates = {};
export const NavigatorItemTop = ({ id, name, router, items, icon, onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const currentPath = location.pathname;
  const [, forceUpdate] = useState({});
  const Icon = navIconMap[icon];
  if (openStates[id] === undefined) {
    openStates[id] = currentPath.startsWith(router);
  }

  const handleToggle = (e) => {
    if (items && items.length > 0) {
      e.stopPropagation();
      openStates[id] = !openStates[id];
      forceUpdate({});
    } else {
      onClick && onClick();
    }
  };

  const isRootPath = (path) => {
    return gUtils.categoriesConf
      .filter((it) => !!it.isRoot)
      .map((it) => it.router)
      .includes(path);
  };

  const isActive = isRootPath(router) ? currentPath === router : currentPath.startsWith(router);

  return (
    <>
      <ListItemButton
        key={id}
        component={items && items.length > 0 ? 'div' : Link}
        to={items && items.length > 0 ? undefined : `${router}`}
        style={{ textDecoration: 'none', color: 'inherit' }}
        onClick={handleToggle}
        sx={isRootPath(router) ? sxStyle(currentPath, router) : sxStyle(currentPath)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
          {Icon && (
            <Icon
              {...(['contacts', 'me'].includes(icon) ? { selected: isActive } : {})}
              size={20}
              sx={{
                fontSize: 20,
                flexShrink: 0,
                color: isActive ? '#28aeb1' : 'inherit',
              }}
            />
          )}

          <ListItemText
            sx={{
              '>span': {
                fontWeight: 'bold',
                color: isActive ? '#28aeb1' : 'inherit',
              },
            }}
          >
            {name ? t(name) : id}
          </ListItemText>
        </Box>
        {items && items.length > 0 && (
          <IconButton>{openStates[id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</IconButton>
        )}
      </ListItemButton>
      {items && (
        <Collapse in={openStates[id]} timeout="auto" unmountOnExit>
          {items.map(({ id, router }) => (
            <Typography
              key={id} // 添加唯一的 key 属性
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${router}`);
                onClick && onClick();
              }}
              sx={{
                marginLeft: '10px',
                marginTop: '4px',
                fontSize: '15px',
                padding: '8px 16px',
                borderRadius: '6px',
                fontWeight: 'bold',
                ...getStyleAttributes(currentPath, router),
                '&:hover': {
                  backgroundColor: '#F8F8F8',
                  cursor: 'pointer',
                },
              }}
            >
              {id}
            </Typography>
          ))}
        </Collapse>
      )}
    </>
  );
};
